import { useQuery } from '@tanstack/react-query';
import {
  ListMerchantCredentialEntity,
  MerchantApiCredentialsService,
} from 'services/openapi';
import { MerchantCredentialQueryKeys } from './constants';
type GetMerchantCredentialListQueryVariables = {
  fetchData?: number;
  page?: number;
  pageIndex?: number;
  pageSize?: number;
  limit?: number;
  companyId?: string;
  status?: 'ACTIVE' | 'INACTIVE';
  search?: string;
};

export const useGetMerchantCredentialListQuery = (
  variables: GetMerchantCredentialListQueryVariables,
) => {
  const isEnabled = !!variables && Object.keys(variables).length > 0;
  const queryKey = [
    MerchantCredentialQueryKeys.GET_MERCHANT_CREDENTIAL_LIST,
    variables,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<ListMerchantCredentialEntity, Error>({
    queryKey,
    queryFn: () => {
      const page =
        variables.page ??
        (typeof variables.pageIndex === 'number'
          ? variables.pageIndex + 1
          : undefined);
      const limit = variables.limit ?? variables.pageSize;

      return MerchantApiCredentialsService.merchantApiControllerListClients(
        variables.companyId,
        variables.status,
        variables.search,
        page,
        limit,
      );
    },
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: false,
    enabled: isEnabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
